import { Form } from "antd";
import React from "react";
import Input from "./BaseInput";

interface OrderItemExternalIdFieldProps {}

const OrderItemExternalIdField: React.FC<OrderItemExternalIdFieldProps> = function (props) {
    return (
        <Form.Item label={<span className=" search-field-label">商品编码</span>} name="orderItemExternalId">
            <Input />
        </Form.Item>
    );
};

export default React.memo(OrderItemExternalIdField);
